// @ts-nocheck

import { use, useEffect, useState } from "react";
import { db } from "../../db/db";
import { useLiveQuery } from "dexie-react-hooks";
import DebugLog from "../DebugLog";

import { API_BASE_URL as publicApiUrl } from "../../utils/api";

function AttendanceSend({ id }) {
  const [log, setLog] = useState();

  const getIsoTimestampFromLocation = (locationValue: any) => {
    if (!locationValue) {
      return undefined;
    }

    try {
      const parsedLocation =
        typeof locationValue === "string"
          ? JSON.parse(locationValue)
          : locationValue;
      const timestamp = parsedLocation?.timestamp;

      if (!timestamp) {
        return undefined;
      }

      const asDate = new Date(timestamp);
      return Number.isNaN(asDate.getTime()) ? undefined : asDate.toISOString();
    } catch (error) {
      console.error("Unable to parse location timestamp", error);
      return undefined;
    }
  };

  const sendVisitStatusUpdate = async (attendance: any) => {
    const start = getIsoTimestampFromLocation(attendance["startLocation"]);
    const end = getIsoTimestampFromLocation(attendance["endLocation"]);

    if (!start || !end) {
      return;
    }

    const payload = {
      id: String(attendance["id"]),
      start,
      end,
    };

    const response = await fetch(
      "https://dashboard.scttrgd.workers.dev/api/visit-status",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      console.error(`visit-status request failed: ${response.status}`);
    }
  };

  const activities = useLiveQuery(async () => {
    return await db.activities.where("postedSuccessfully").equals(0).toArray();
  });
  const [readyAttendances, setReadyAttendances] = useState([]);
  const constructAttendanceData = (attendance: any) => {
    console.table(attendance);
    let attendanceData: any = {
      c: "ltgb2qzc31qn88xor",
      t: "l1_logger",
      logged_by_0: id && id["id"],
      start_logged_at: JSON.parse(attendance["startLocation"])["timestamp"],
      start_logged_lat: JSON.parse(attendance["startLocation"])["coords"][
        "latitude"
      ],
      start_logged_long: JSON.parse(attendance["startLocation"])["coords"][
        "longitude"
      ],
      end_logged_lat: JSON.parse(attendance["endLocation"])["coords"][
        "latitude"
      ],
      end_logged_long: JSON.parse(attendance["endLocation"])["coords"][
        "longitude"
      ],
      end_logged_at: JSON.parse(attendance["endLocation"])["timestamp"],
    };
    if (attendance["notes"]) {
      attendanceData.note = attendance["notes"];
      attendanceData.highlight_for_next_visit = attendance["flagForNextVisit"]
        ? "true"
        : "false";
    }
    if (attendance["rowId"]) {
      attendanceData.update_record = "true";
      attendanceData.row_id = attendance["rowId"];
    } else {
      attendanceData.save_new_record = "true";
    }
    // if (attendance["aborted"] == true) {
    //   save_new_record: "true",

    // }
    if (attendance["type"] == "HC") {
      if (attendance["manualTime"]) {
        const difference = Math.abs(
          attendance["manualTime"] - attendance["correctLength"]
        );
        attendanceData.amount_of_time_logged = attendance["manualTime"];
        attendanceData.reason_for_non_full_completion = attendance["reason"];
        if (difference > 5) {
          if (attendance["manualTime"] > attendance["correctLength"]) {
            attendanceData.confirm_full_duration_completed = "2) No - Over";
          } else {
            attendanceData.confirm_full_duration_completed = "2) No - Under";
          }
        } else {
          attendanceData.confirm_full_duration_completed = "1) Yes";
        }
      } else {
        // attendanceData.amount_of_time_logged = attendance["correctLength"];
        // attendanceData.reason_for_non_full_completion = attendance["reason"];
        attendanceData.confirm_full_duration_completed = "1) Yes";
      }
    } else {
      attendanceData.confirm_full_duration_completed = "1) Yes";
    }

    if (attendance["aborted"]) {
      attendanceData.aborted_0 = attendance["aborted"];
    }
    if (attendance["aborted_reason"]) {
      attendanceData.aborted = attendance["aborted_reason"];
    }
    if (attendance["type"] == "HC") {
      attendanceData.hc_visit_0 = attendance["id"];
    }
    if (attendance["type"] == "SL") {
      attendanceData.sl_session_0 = attendance["id"];
    }
    if (attendance["type"] == "Com Out") {
      attendanceData.com_out_visit_0 = attendance["id"];
    }
    return attendanceData;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(Date.now());
    }, 300000);
    return () => clearInterval(interval);
  }, []);

  const incidents = useLiveQuery(async () => {
    return await db.incidents.where("postedSuccessfully").equals(0).toArray();
  });

  const issues = useLiveQuery(async () => {
    return await db.issues.toArray();
  });

  const attendances = useLiveQuery(async () => {
    return await db.attendances.where("postedSuccessfully").equals(0).toArray();
  });

  const adhocs = useLiveQuery(async () => {
    return await db.adhoc.where("postedSuccessfully").equals(0).toArray();
  });


  useEffect(() => {
    if (adhocs?.length > 0) {
      adhocs.map((adhoc) => {
        const bodyData = adhoc;
        bodyData.rdpartyintid_4 = adhoc["id"];
        // bodyData.remove(id);
        const body = new URLSearchParams(bodyData).toString();
        fetch(`${publicApiUrl}/attendance`, {
          body: body,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
          .then((res) => res.json())
          .then((json) => setLog(`Successfully posted to Agilebase ${json}`))
          .then((result) => {
            db.adhoc
              .update(adhoc["id"], {
                postedSuccessfully: 1,
              })
              .then(() => setLog("Update postedSuccessfully in local db"));
          });
      });
    }
  }, [adhocs]);
  useEffect(() => {
    if (readyAttendances.length > 0) {
      readyAttendances.map((attendance) => {
        const bodyData = attendance;
        bodyData.rdpartyintid_4 = attendance["id"];
        const body = new URLSearchParams(
          constructAttendanceData(bodyData)
        ).toString();
        setLog(`Sending: ${body}`);
        console.table(attendance);
        fetch(`${publicApiUrl}/attendance`, {
          body: body,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
          // .then((res) => res.json())
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            return Promise.reject(response);
          })
          //       .then(function(response) {                      // first then()
          // if(response.ok)
          // {
          //   return response.text();
          // }

          // throw new Error('Something went wrong.');
          .then((response) => {
            setLog(`Success: ${JSON.stringify(response)}`);
            db.attendances.update(attendance["id"], {
              postedSuccessfully: 1,
              rowId: response["rowId"],
            });

            // Fire and forget so the existing attendance flow is never blocked.
            void sendVisitStatusUpdate(attendance);
          })
          .catch((response) => {
            console.log(response.status, response.statusText);
            // 3. get error messages, if any
            response.json().then((json) => {
              setLog(`Error: ${JSON.stringify(json)}`);
            });
          });
      });
    }
  }, [readyAttendances]);

  useEffect(() => {
    if (attendances?.length > 0) {
      setReadyAttendances(
        attendances.filter(
          (attendance) =>
            attendance.endLocation !== undefined &&
            attendance.readyToPost !== 0 &&
            attendance.endLocation !== "false" &&
            attendance.endLocation !== false
        )
      );
      console.table(
        attendances.filter(
          (attendance) =>
            attendance.endLocation !== undefined &&
            attendance.readyToPost !== 0 &&
            attendance.endLocation !== "false" &&
            attendance.endLocation !== false
        )
      );
    } else {
      setReadyAttendances([]);
    }
  }, [attendances]);

  return <DebugLog log={log} />;
}

export default AttendanceSend;
